import { PASSWORD_RULES } from '@/constants/common';
import { Box, List, ListItem, Typography } from '@mui/material';

export default function PasswordRules() {
  return (
    <Box>
      <Typography mb={2}>
        Enter a password. Passwords must meet the following criteria:
      </Typography>
      <List sx={{ p: '0' }}>
        {PASSWORD_RULES.map(rule => (
          <ListItem
            sx={{
              p: '2px 0',
              ml: '30px',
              display: 'list-item',
              listStyleType: 'disc',
            }}
            key={rule}>
            <Typography>{rule}</Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
